import PercentageCircle, {
  getPercentageCircleDefaultBandHex,
} from "@/components/shared/PercentageCircle";
import Table, { ColumeDef } from "@/components/shared/Table";
import dateFormatter from "@/helperFuntions/dateFormater";
import { Project } from "../../api/query/useProjectQuery";
import { useEffect, useMemo, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import CreateUpdateProjectForm from "@/components/project/CreateProjectForm";
import NoProject from "../../components/project/NoProject";
import Loader from "@/components/common/Loader";
import UserAvatar from "@/components/ui/userAvatar";
import NewEditIcon from "@/assets/v2/svg/PrimaryEdit.svg";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ScrollText, Settings } from "lucide-react";
import { ForecastBudgetVarianceTooltipContent } from "@/components/common/ForecastBudgetVarianceTooltipContent";
import { SpiTooltipContent } from "@/components/common/SpiTooltipContent";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import { useQueryClient } from "@tanstack/react-query";
import { QUERY_KEYS } from "@/api/query/querykeys";
import { getCurrentOrgRole, getCurrentUserOrganisation } from "@/utils/roleUtils";
import countries from "@/assets/json/countries.json";
import CreateProjectForm from "../../components/project/CreateProjectForm";
import HierarchyImportModal from "@/components/shared/HierarchyImportModal";
import useReferenceDataQuery from "@/api/query/useReferenceDataQuery";
import {
  PlanTypeEnumSchema,
  ProjectDefaultViewEnumValue,
  ProjectStatusEnumValue,
  UserRoleEnumValue,
} from "@backend/src/schemas/enums";
import useProjectDuplicateMutation from "@/api/mutation/useDuplicateProject";
import { toast } from "react-toastify";
import TaskDetailModal from "@/components/tasks/taskDetailModal";
import DuplicateIcon from "@/assets/svg/DuplicateIcon.svg";
import Users from "@/assets/svg/Users.svg";
import { useUser } from "@/hooks/useUser";
import { errorConfig } from "@/lib/toastError";
import Dialog from "@/components/common/Dialog";
import useRemoveProjectMutation from "@/api/mutation/useProjectRemoveMutation";
import useBulkDeleteProjectsMutation from "@/api/mutation/useBulkDeleteProjectsMutation";
import TrashCan from "@/assets/v2/svg/trash.svg";
import Plus from "@/assets/svg/NoramlPlus.svg";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useTranslation } from "react-i18next";
import { errorKeyFormate } from "@/helperFuntions/errroMessage";
import { usePlanValidation } from "@/hooks/usePlan";
import InputText from "@/components/common/InputText";
import DeletePortfolioProgramConfirmDialog from "@/components/project/DeletePortfolioProgramConfirmDialog";
import usePortfolioUpdateMutation from "@/api/mutation/useUpdatePortfolioMutation";
import useProgramUpdateMutation from "@/api/mutation/useProgramUpdateMutaion";
import useRemoveProgramMutation from "@/api/mutation/useRemoveProgramMutaiton";
import useRemovePortfolioMutation from "@/api/mutation/useRemovePortfolioMutaiton";
import gantt from "@/assets/svg/ganttNew.svg";
import list from "@/assets/svg/listNew.svg";
import CloseCircle from "@/assets/v2/svg/primary-close-circle.svg";
import CheckedSvg from "@/assets/v2/svg/tick-circle.svg";
import Sunny from "@/assets/svg/sunny.svg";
import Cloudy from "@/assets/svg/cloudy.svg";
import Rainy from "@/assets/svg/Rainy.svg";
import Stormy from "@/assets/svg/stormy.svg";
import GanttView from "./ganttView";
import NoFilterProject from "./noProject";
import ProjectFilter from "./projectFilter";
import { FIELDS } from "@/api/types/enums";
import dateFormater from "@/helperFuntions/dateFormater";
import Collaps from "@/assets/v2/svg/collaps.svg";
import Expand from "@/assets/v2/svg/expand.svg";
import ZoomOut from "@/assets/v2/svg/zoom-out.svg";
import ZoomIn from "@/assets/v2/svg/zoom-in.svg";
import FullScreen from "@/assets/v2/svg/full-screen.svg";
import ExitFullscreen from "@/assets/svg/ExitFullscreen.svg";
import Refresh from "@/assets/v2/svg/refresh.svg";
import ExcelJS from "exceljs";
import Select from "react-select";
import { Options } from "@/components/views/ganntView/GanttView";
import InfoCircle from "@/assets/png/information.png";
import crossNew from "@/assets/svg/crossNew.svg";
import DownLoadIcon from "@/assets/svg/DownLoad.svg";
import UploadIcon from "@/assets/svg/Uploadsvg.svg";
import useProjectManagerPortfolioDashboardQuery from "@/api/query/useProjectManagerPortfolioDashboardQuery";
import {
  canDuplicateOrRemoveProject,
  canManagePortfolioHierarchyRow,
  canManageProgramHierarchyRowEnhanced,
  canManageProjectTasksAndContent,
  normalizeProjectScope,
} from "@/utils/projectRoleAccess";
import InfoProgressCircle from "@/assets/png/information.png";
import {
  getSpiScheduleIndicatorHex,
  getScheduleFlagInfo,
  getBudgetFlagInfo,
} from "@/helperFuntions/spiScheduleColor";

import {
  useProjectHierarchy,
  type HierarchyItem,
  type PortfolioNode,
  type ProgramNode,
  type ProjectNode,
} from "@/hooks/useProjectHierarchy";
import useProjectFieldLabels from "@/hooks/useProjectFieldLabels";

const reactSelectStyle = {
  control: (
    provided: Record<string, unknown>,
    state: { isFocused: boolean },
  ) => ({
    ...provided,
    border: "1px solid #E7E7E7",
    paddingTop: "0rem",
    paddingBottom: "0rem",
    outline: state.isFocused ? "2px solid #535EF9" : "0px solid #E7E7E7",
    boxShadow: state.isFocused ? "0px 0px 0px #535EF9" : "none",
    "&:hover": {
      outline: "2px solid #535EF9",
      boxShadow: "0px 0px 0px #535EF9",
    },
  }),
  option: (
    provided: Record<string, unknown>,
    state: { isSelected: boolean },
  ) => ({
    ...provided,
    color: state.isSelected ? "white" : "black",
    background: state.isSelected ? "#535EF9" : "white",
    "&:hover": {
      color: "white",
      background: "#535EF999",
    },
  }),
  menu: (provided: Record<string, unknown>) => ({
    ...provided,
    zIndex: 99999,
  }),
  menuPortal: (provided: Record<string, unknown>) => ({
    ...provided,
    zIndex: 99999,
  }),
};

//================================================================
// PROJECTS LIST COMPONENT
//================================================================

function ProjectsList() {
  const [data, setData] = useState<Project[]>();
  const [filterData, setFilterData] = useState<Project[]>();
  const queryClient = useQueryClient();

  const projectTypesQuery = useReferenceDataQuery("project-type", true);
  const projectPhasesQuery = useReferenceDataQuery("project-phase", true);
  const projectPrioritiesQuery = useReferenceDataQuery("project-priority", true);
  const projectCategoriesQuery = useReferenceDataQuery("project-category", true);
  const workstreamsQuery = useReferenceDataQuery("workstream", true);

  // State now uses the new, strongly-typed HierarchyItem
  const [hierarchyData, setHierarchyData] = useState<HierarchyItem[]>([]);

  const [isOpenPopUp, setIsOpenPopUp] = useState(false);
  const [isImportOpen, setIsImportOpen] = useState(false);
  const [editData, setEditData] = useState<Project | undefined>();
  const [projectId, setProjectId] = useState<string>();
  const { user } = useUser();
  const navigate = useNavigate();
  // const projectQuery = useProjectQuery(true);
  const [searchParams] = useSearchParams();
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [remove, setRemove] = useState<string>();
  const removeProjectMutation = useRemoveProjectMutation();
  const bulkDeleteMutation = useBulkDeleteProjectsMutation();
  const { t } = useTranslation();
  const projectFieldLabels = useProjectFieldLabels();
  
  // Bulk delete state
  const [selectedProjectIds, setSelectedProjectIds] = useState<Set<string>>(new Set());
  const [showBulkDeleteDialog, setShowBulkDeleteDialog] = useState(false);
  const [bulkDeleteConfirmText, setBulkDeleteConfirmText] = useState("");
  
  const isAdmin = user?.userOrganisation?.some(
    (org) => org.role === UserRoleEnumValue.ADMINISTRATOR,
  ) ?? false;
  
  const viewOption = [
    {
      icon: list,
      view: t("list"),
      value: ProjectDefaultViewEnumValue.LIST,
    },
    {
      icon: gantt,
      view: t("rode_map"),
      value: ProjectDefaultViewEnumValue.GANTT,
    },
  ];
  const [view, setView] = useState(() => {
    const viewParam = searchParams.get("view");
    return viewParam ? (viewParam as keyof typeof ProjectDefaultViewEnumValue) : viewOption[1].value;
  });
  const [loader, setLoader] = useState(true);
  useEffect(() => {
    if (user && (!user.firstName || !user.lastName)) {
      navigate("/account-settings", { state: { edit: true } });
    }
  }, [user]);

  const portfolioDashboardParams = useMemo(
    () => ({ portfolioId: "", programId: "", page: 1, limit: 100000 }),
    [],
  );
  const projectQuery = useProjectManagerPortfolioDashboardQuery(
    portfolioDashboardParams,
    true,
  );
  const projectListSearchKey = searchParams.toString();
  useEffect(() => {
    setLoader(true);
    if (!projectQuery.isFetched) {
      void projectQuery.refetch();
    }

    const raw =
      (projectQuery.data?.data.data.projects as unknown as Project[]) ?? [];
    const overallFilter = searchParams.get("overall");
    const filtered = raw.filter((project) =>
      overallFilter ? overallFilter === project.overallTrack : true,
    );
    setData(
      filtered.map((t: Project & { projectActualStartDate?: string }) => ({
        ...t,
        actualStartDate:
          t.projectActualStartDate ?? t.actualStartDate ?? "",
      })),
    );
    setLoader(false);
  }, [
    projectQuery.data?.data.data,
    projectQuery.isFetched,
    projectListSearchKey,
  ]);

  useEffect(() => {
    const viewParam = searchParams.get("view");
    if (viewParam) {
      setView(viewParam as keyof typeof ProjectDefaultViewEnumValue);
    }
    const compareParam = searchParams.get("compare");
    if (compareParam) {
      setCompare(
        compareParam as "estimatedToActual" | "actualToReCalculated" | "all",
      );
      if (compareParam === "actualToReCalculated") {
        setSelectedDateType("actual");
      }
    }
  }, [searchParams]);

  const { buildCompleteHierarchy } = useProjectHierarchy();

  // 3. UPDATED useEffect TO USE THE NEW LOGIC
  useEffect(() => {
    const newData = buildCompleteHierarchy(filterData ?? []);
    setHierarchyData(newData);
  }, [filterData, buildCompleteHierarchy]);

  const close = () => {
    setIsOpenPopUp(false);
    setEditData(undefined);
    setProjectId(undefined);
  };

  const handleView = (id: string) => {
    const project = (projectQuery.data?.data.data.projects as unknown as Project[])?.find((p) => p.projectId === id);
    if (project && project.isActive === false) {
      setShowUpgradeModal(true);
      return;
    }
    navigate("/project-details/" + id);
  };

  const [isPopUpOpen, setIsPopUpOpen] = useState(false);
  const { validatePlan } = usePlanValidation();

  const handleOpenPopUp = () => {
    if (validatePlan("project").valid) {
      setIsPopUpOpen(!isPopUpOpen);
    }
  };

  const projectDuplicateMutation = useProjectDuplicateMutation();
  const createDuplicate = (id: string) => {
    if (!validatePlan("project").valid) {
      return;
    }
    projectDuplicateMutation.mutate(id, {
      onSuccess(data) {
        toast.success(data.data.message);
        projectQuery.refetch();
      },
      onError(error) {
        toast.error(
          errorKeyFormate(error.response?.data.message + ""),
          errorConfig,
        );
      },
    });
  };
  const [showInput, setShowInput] = useState("");
  const [updateValue, setUpdateValue] = useState<{
    type: "portfolio" | "program";
    id: string;
    value: string;
  }>();

  const portfolioUpdateMutation = usePortfolioUpdateMutation();
  const programUpdateMutation = useProgramUpdateMutation();
  const updatePortfolioAndProgram = () => {
    if (updateValue && updateValue.type == "portfolio" && updateValue.value) {
      portfolioUpdateMutation.mutate(
        { id: updateValue.id, value: updateValue.value },
        {
          onSuccess() {
            setUpdateValue(undefined);
            setShowInput("");
            projectQuery.refetch();
          },
          onError(error) {
            toast.error(
              errorKeyFormate(error.response?.data.message ?? ""),
              errorConfig,
            );
          },
        },
      );
    } else if (
      updateValue &&
      updateValue.type == "program" &&
      updateValue.value
    ) {
      programUpdateMutation.mutate(
        { id: updateValue.id, value: updateValue.value },
        {
          onSuccess() {
            setUpdateValue(undefined);
            setShowInput("");
            projectQuery.refetch();
          },
          onError(error) {
            toast.error(
              errorKeyFormate(error.response?.data.message ?? ""),
              errorConfig,
            );
          },
        },
      );
    } else {
      setUpdateValue(undefined);
      setShowInput("");
    }
  };
  const fullScreen = useRef<HTMLDivElement | null>(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [showMilestones, setShowMilestones] = useState(true);

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);

      const navbar = document.getElementById("navbar");
      const sidebar = document.getElementById("Sidebar");

      if (document.fullscreenElement) {
        if (navbar) navbar.classList.add("!hidden");
        if (sidebar) sidebar.classList.add("!hidden");
      } else {
        if (navbar) navbar.classList.remove("!hidden");
        if (sidebar) sidebar.classList.remove("!hidden");
      }
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    if (document.fullscreenElement) {
      handleFullscreenChange();
    }
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  useEffect(() => {
    const hiddenKey = "projects_list_hidden_columns";
    const hiddenStored = localStorage.getItem(hiddenKey);
    if (hiddenStored) {
      try {
        const hidden: string[] = JSON.parse(hiddenStored);
        if (hidden.includes("cpi")) {
          const newHidden = hidden.filter((k) => k !== "cpi");
          localStorage.setItem(hiddenKey, JSON.stringify(newHidden));
        }
      } catch {
        // ignore
      }
    }
  }, []);

  const enterFullscreen = () => {
    const elem = document.documentElement;

    if (!isFullscreen) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  };
  const [deletePortfolioAndProgram, setDeletePortfolioAndProgram] = useState<{
    portfolio: string;
    program: string;
  }>();
  const toNum = (val: any, fallback = 0) => {
    const num = parseFloat(val);
    return isFinite(num) ? num : fallback;
  };

  const projectsListDateColumnKeys = [
    "startDate",
    "actualEndDate",
    "estimatedEndDate",
    "actualEndDateDashboard",
    "recalCulatedEndDate",
  ];

  const projectsListTableClassName =
    "border-separate border-spacing-y-1 border-spacing-x-0 min-w-[max(100%,max-content)] w-full table-auto";

  const isGroupHierarchyRow = (row: { type?: string }) =>
    row?.type === "portfolio" || row?.type === "program";

  const groupRowCell = (
    <span className="text-base font-medium text-gray-400">-</span>
  );

  const scheduleIndicatorDelayRange = {
    onTimeDelayMax:
      getCurrentUserOrganisation(user)?.organisation?.onTimeDelayMax ?? 5,
    moderateDelayMax:
      getCurrentUserOrganisation(user)?.organisation?.moderateDelayMax ?? 20,
  };
  const visibleProjectIds = useMemo(
    () => (filterData ?? []).map((p) => p.projectId),
    [filterData],
  );

  useEffect(() => {
    setSelectedProjectIds((prev) => {
      const next = new Set(prev);
      let changed = false;
      for (const id of prev) {
        if (!visibleProjectIds.includes(id)) {
          next.delete(id);
          changed = true;
        }
      }
      return changed ? next : prev;
    });
  }, [visibleProjectIds]);

  const handleSelectAll = (checked: boolean) => {
    if (checked) {
      setSelectedProjectIds(new Set(visibleProjectIds));
    } else {
      setSelectedProjectIds(new Set());
    }
  };

  const handleSelectRow = (projectId: string, checked: boolean) => {
    setSelectedProjectIds((prev) => {
      const next = new Set(prev);
      if (checked) {
        next.add(projectId);
      } else {
        next.delete(projectId);
      }
      return next;
    });
  };

  const handleBulkDelete = () => {
    if (bulkDeleteConfirmText !== "DELETE") {
      return;
    }
    const ids = Array.from(selectedProjectIds);
    bulkDeleteMutation.mutate({ projectIds: ids }, {
      onSuccess: () => {
        toast.success(t("projects_bulk_deleted_successfully"));
        setSelectedProjectIds(new Set());
        setShowBulkDeleteDialog(false);
        setBulkDeleteConfirmText("");
        projectQuery.refetch();
      },
      onError: (error) => {
        toast.error(
          errorKeyFormate(error.response?.data.message ?? ""),
          errorConfig,
        );
      }
    });
  };

  // 4. COLUMN DEFINITION UPDATED TO HANDLE NEW DATA STRUCTURE
  const baseColumnDef: ColumeDef[] = [
    {
      key: "projectName",
      header: t("project_name"),
      sorting: true,
      width: 260,
      colspan: () => 1,
      onCellRender: (item: HierarchyItem) => {
        return (
          <div className="w-full flex items-center justify-between gap-2">
            {item.type === "project" && (
              <div className={`text-left truncate ${(item as any)?.portfolioportfolioId && (item as any)?.programprogramId ? "max-w-36" : (item as any)?.portfolioportfolioId || (item as any)?.programprogramId ? "" : ""}`}>                {item.isActive ? (
                <TooltipProvider delayDuration={0}>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <Link
                        className="text-primary-500 underline "
                        to={
                          user?.subscription?.planType ==
                            PlanTypeEnumSchema.FREE || !user?.subscription
                            ? `/tasks/${item.projectId}`
                            : `/projectDashboard/${item.projectId}`
                        }
                      >
                        {item.projectName}
                      </Link>
                    </TooltipTrigger>
                    <TooltipContent>{item.projectName}</TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              ) : (
                <TooltipProvider delayDuration={0}>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <div className="flex items-center gap-2">
                        <img src={CloseCircle} className="w-5 max-w-5" />
                        <div className={`truncate w-32 `}>
                          {item.projectName}
                        </div>
                      </div>
                    </TooltipTrigger>
                    <TooltipContent>{item.projectName}</TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              )}
              </div>
            )}

            {item.type === "program" ? (
              <div className=" max-w-[20rem]">
                {showInput == item.programId ? (
                  <div className="flex gap-2 items-center">
                    <InputText
                      className="mt-0 my-2 h-[40px]"
                      defaultValue={item.programName ?? ""}
                      onKeyDown={(e) =>
                        e.key == "Enter" ? updatePortfolioAndProgram() : ""
                      }
                      onChange={(e) => {
                        const val = e.target.value;
                        setUpdateValue({
                          type: "program",
                          id: item.programId,
                          value: val,
                        });
                      }}
                    />
                    <span
                      className={` cursor-pointer `}
                      onClick={(e) => {
                        e.stopPropagation();
                        updatePortfolioAndProgram();
                      }}
                    >
                      <img src={CheckedSvg} className="w-5 max-w-5" />
                    </span>
                    <span
                      className={`font-bold text-sm text-red-400 cursor-pointer `}
                      onClick={(e) => {
                        e.stopPropagation();
                        setUpdateValue(undefined);
                        setShowInput("");
                      }}
                    >
                      <img src={CloseCircle} className="w-5 max-w-5" />
                    </span>
                  </div>
                ) : (
                  <div className="flex gap-2 items-center">
                    <div className="h-14 flex items-center truncate ">
                      {item.programName}
                    </div>
                    {user &&
                      canManageProgramHierarchyRowEnhanced(user, item.programId, item.portfolioId) && (
                        <div className="row-action-buttons flex gap-1 items-center">
                          <img
                            src={NewEditIcon}
                            className=" h-4.5 w-4.5 w-4 cursor-pointer"
                            onClick={(e) => {
                              e.stopPropagation();
                              setShowInput(item.programId);
                            }}
                          />
                          <img
                            src={TrashCan}
                            className="mr-2 h-4.5 w-4.5 w-4 cursor-pointer"
                            onClick={(e) => {
                              e.stopPropagation();
                              setDeletePortfolioAndProgram({
                                portfolio: "",
                                program: item.programId,
                              });
                            }}
                          />
                        </div>
                      )}
                  </div>
                )}
              </div>
            ) : item.type === "portfolio" ? (
              <div className=" max-w-[26rem]">
                {showInput == item.portfolioId ? (
                  <div className="flex gap-2 items-center">
                    <InputText
                      className="mt-0 my-2 h-[40px]"
                      defaultValue={item.portfolioName ?? ""}
                      onKeyDown={(e) =>
                        e.key == "Enter" ? updatePortfolioAndProgram() : ""
                      }
                      onChange={(e) => {
                        const val = e.target.value;
                        setUpdateValue({
                          type: "portfolio",
                          id: item.portfolioId,
                          value: val,
                        });
                      }}
                    />
                    <span
                      className={` cursor-pointer `}
                      onClick={(e) => {
                        e.stopPropagation();
                        updatePortfolioAndProgram();
                      }}
                    >
                      <img src={CheckedSvg} className="w-5 max-w-5" />
                    </span>
                    <span
                      className={`font-bold text-xs text-red-400 cursor-pointer `}
                      onClick={(e) => {
                        e.stopPropagation();
                        setUpdateValue(undefined);
                        setShowInput("");
                      }}
                    >
                      <img src={CloseCircle} className="w-5 max-w-5" />
                    </span>
                  </div>
                ) : (
                  <div className="flex gap-2 items-center">
                    <div className="h-14 flex items-center !truncate ">
                      {item.portfolioName}
                    </div>
                    {user &&
                      canManagePortfolioHierarchyRow(user, item.portfolioId) && (
                        <div className="row-action-buttons flex gap-1 items-center">
                          <img
                            src={NewEditIcon}
                            className="h-4.5 w-4.5  w-4 cursor-pointer"
                            onClick={(e) => {
                              e.stopPropagation();
                              setShowInput(item.portfolioId);
                            }}
                          />
                          <img
                            src={TrashCan}
                            className="mr-2 h-4.5 w-4.5  w-4 cursor-pointer"
                            onClick={(e) => {
                              e.stopPropagation();
                              setDeletePortfolioAndProgram({
                                portfolio: item.portfolioId,
                                program: "",
                              });
                            }}
                          />
                        </div>
                      )}
                  </div>
                )}
              </div>
            ) : (
              ""
            )}
          </div>
        );
      },
    },
    {
      key: "createdByUser",
      header: t("Manager"),
      width: 100,
      onCellRender: (item: HierarchyItem) => {
        if (item.type == "project") {
          const userPm = item.assignedUsers?.find((u) => {
            return u?.projectRole == UserRoleEnumValue.PROJECT_MANAGER;
          });
          return userPm ? (
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <div className="ml-3 flex">
                    <div>
                      <UserAvatar
                        className="shadow-sm shadow-gray-300 border-2 border-white"
                        user={userPm?.user}
                      />
                    </div>
                  </div>
                </TooltipTrigger>
                <TooltipContent>
                  <div className="text-sm space-y-0.5">
                    <div>
                      {t("Role")}: {t((userPm?.projectRole || "").toLowerCase())}
                    </div>
                    {userPm?.user.firstName && userPm?.user.lastName && (
                      <div>
                        {t("name")}:{" "}
                        {`${userPm?.user.firstName} ${userPm?.user.lastName}`}
                      </div>
                    )}
                    <div>
                      {t("Email")}: {userPm?.user.email}
                    </div>
                  </div>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          ) : (
            groupRowCell
          );
        } else if (item.type == "portfolio") {
          const portfolioManager = item.assignedUsers?.[0];
          return portfolioManager ? (
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <div className="ml-3 flex">
                    <div>
                      <UserAvatar
                        className="shadow-sm shadow-gray-300 border-2 border-white"
                        user={portfolioManager?.user}
                      />
                    </div>
                  </div>
                </TooltipTrigger>
                <TooltipContent>
                  <div className="text-sm space-y-0.5">
                    <div>
                      {t("Role")}:{" "}
                      {t(
                        (portfolioManager?.portfolioRole || "").toLowerCase(),
                      )}
                    </div>
                    {portfolioManager?.user.firstName &&
                      portfolioManager?.user.lastName && (
                        <div>
                          {t("name")}:{" "}
                          {`${portfolioManager?.user.firstName} ${portfolioManager?.user.lastName}`}
                        </div>
                      )}
                    <div>
                      {t("Email")}: {portfolioManager?.user.email}
                    </div>
                  </div>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          ) : (
            groupRowCell
          );
        } else if (item.type == "program") {
          const programManager = item.assignedUsers?.[0];
          return programManager ? (
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <div className="ml-3 flex">
                    <div>
                      <UserAvatar
                        className="shadow-sm shadow-gray-300 border-2 border-white"
                        user={programManager?.user}
                      />
                    </div>
                  </div>
                </TooltipTrigger>
                <TooltipContent>
                  <div className="text-sm space-y-0.5">
                    <div>
                      {t("Role")}:{" "}
                      {t((programManager?.programRole || "").toLowerCase())}
                    </div>
                    {programManager?.user.firstName &&
                      programManager?.user.lastName && (
                        <div>
                          {t("Name")}:{" "}
                          {`${programManager?.user.firstName} ${programManager?.user.lastName}`}
                        </div>
                      )}
                    <div>
                      {t("Email")}: {programManager?.user.email}
                    </div>
                  </div>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          ) : (
            groupRowCell
          );
        }
        return groupRowCell;
      },
    },
    {
      key: "progressionPercentage",
      header: t("Actual Progress"),
      width: 118,

      sorting: true,
      onCellRender: (item: HierarchyItem) => {
        if (isGroupHierarchyRow(item)) {
          const groupItem = item as PortfolioNode | ProgramNode;
          return (
            <div>
              <PercentageCircle
                percentage={groupItem.actualProgress ?? 0}
              />
            </div>
          );
        }
        const spiColor = getSpiScheduleIndicatorHex(
          item.type === "project" ? item.spi : undefined,
          scheduleIndicatorDelayRange,
        );

        return (
          <div>
            <PercentageCircle
              percentage={Number((item as any)?.progressionPercentage) * 100} // Use the calculated progress for all types
              roundColor={spiColor}
            />
          </div>
        );
      },
    },
    {
      key: "expectedprogress",
      header: t("expected_progress"),
      width: 128,
      sorting: true,
      onCellRender: (item: Project) => {
        if (isGroupHierarchyRow(item as HierarchyItem)) {
          const groupItem = item as unknown as PortfolioNode | ProgramNode;
          const actualPct = groupItem.actualProgress ?? 0;
          return (
            <div>
              <PercentageCircle
                percentage={Math.min(groupItem.expectedProgress ?? 0, 100)}
                roundColor={getPercentageCircleDefaultBandHex(actualPct)}
              />
            </div>
          );
        }
        const spiColor = getSpiScheduleIndicatorHex(
          item.spi,
          scheduleIndicatorDelayRange,
        );

        return (
          <div>
            <PercentageCircle
              percentage={Math.min(toNum(Number(item.expectedprogress), 0), 100)} // Use the calculated progress for all types
              roundColor={spiColor}
            />
          </div>
        );
      },
    },
    {
      key: "status",
      header: t("status"),
      width: 120,
      sorting: true,
      onCellRender: (item: HierarchyItem) =>
        item.type === "project" ? (
          <div className="flex justify-center w-full">
            <div
              className={`w-28 h-8 px-3 py-1.5 ${getStatusColor(
                item.status,
              )} rounded-full justify-center items-center gap-px inline-flex whitespace-nowrap`}
            >
              <div className=" text-xs font-medium leading-tight whitespace-nowrap">
                {t(item.status)}
              </div>
            </div>
          </div>
        ) : (
          groupRowCell
        ),
    },
    {
      key: "overallTrack",
      header: t("Overall Health"),
      width: 130,
      sorting: true,
      onCellRender: (item: HierarchyItem) => {
        if (item.type !== "project") return groupRowCell;
        const track = (item as any)?.overallTrack;
        let label = "";
        let colorClass = "";
        let icon = null;
        if (track === "SUNNY") {
          label = t("Healthy");
          colorClass = "text-[#22C55E]";
          icon = <img src={Sunny} className="h-4 w-4" />;
        } else if (track === "CLOUDY" || track === "RAINY") {
          label = t("At Risk");
          colorClass = "text-[#FAB415]";
          icon = <img src={track === "CLOUDY" ? Cloudy : Rainy} className="h-4 w-4" />;
        } else if (track === "STORMY") {
          label = t("Critical");
          colorClass = "text-[#EF4444]";
          icon = <img src={Stormy} className="h-4 w-4" />;
        } else {
          label = t("Healthy");
          colorClass = "text-[#22C55E]";
          icon = <img src={Sunny} className="h-4 w-4" />;
        }
        return (
          <div className={`flex items-center gap-1.5 font-semibold text-xs ${colorClass}`}>
            {icon}
            {label}
          </div>
        );
      },
    },
    {
      key: "scheduleFlag",
      header: t("Schedule"),
      width: 130,
      sorting: true,
      onCellRender: (item: HierarchyItem) => {
        if (item.type !== "project") return groupRowCell;
        const org = getCurrentUserOrganisation(user)?.organisation;
        const flag = getScheduleFlagInfo(
          item.status,
          (item as any)?.spi,
          {
            onTimeDelayMax: org?.onTimeDelayMax,
            moderateDelayMax: org?.moderateDelayMax,
          },
          {
            actualStartDate: (item as any)?.actualStartDate,
            projectActualStartDate: (item as any)?.projectActualStartDate,
            startDate: item.startDate,
          },
        );

        return (
          <div className={`px-2.5 py-1 rounded-full text-xs font-bold inline-flex items-center justify-center ${flag.badgeClass}`}>
            {t(flag.labelKey, flag.defaultLabel)}
          </div>
        );
      },
    },
    {
      key: "spi",
      header: t("spi"),
      width: 100,
      sorting: true,
      onCellRender: (item: Project) =>
        isGroupHierarchyRow(item as HierarchyItem) ? (
          groupRowCell
        ) : (
          <div className="flex gap-1  items-center">
            {item.spi ? item.spi.toFixed() : (0).toFixed()}%
            <img
              src={InfoCircle}
              className="min-w-4 w-4 brightness-0 invert"
              alt="InfoCircle"
            />
          </div>
        ),
      onHeaderRender: (item: string) => (
        <>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger className="flex gap-1  items-center uppercase">
                <span className="uppercase">{t(item)}</span>
                <img
                  src={InfoProgressCircle}
                  className="min-w-4 w-4"
                  alt="InfoCircle"
                />
              </TooltipTrigger>
              <TooltipContent className="z-50 normal-case p-0 bg-white border border-slate-200 shadow-xl rounded-xl" sideOffset={30}>
                <SpiTooltipContent />
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </>
      ),
    },
    {
      key: "budgetFlag",
      header: t("Budget"),
      width: 130,
      sorting: true,
      onCellRender: (item: HierarchyItem) => {
        if (item.type !== "project") return groupRowCell;
        const org = getCurrentUserOrganisation(user)?.organisation;
        const flag = getBudgetFlagInfo(
          item.status,
          undefined,
          {
            onBudgetMax: org?.onBudgetMax,
            moderateBudgetMax: org?.moderateBudgetMax,
          },
          {
            actualStartDate: (item as any)?.actualStartDate,
            projectActualStartDate: (item as any)?.projectActualStartDate,
            startDate: item.startDate,
          },
          (item as any)?.forecastBudgetVariance,
        );

        return (
          <div className={`px-2.5 py-1 rounded-full text-xs font-bold inline-flex items-center justify-center ${flag.badgeClass}`}>
            {t(flag.labelKey, flag.defaultLabel)}
          </div>
        );
      },
    },
    {
      key: "forecastBudgetVariance",
      header: t("forecast_budget_variance"),
      width: 155,
      sorting: true,
      onCellRender: (item: Project) => {
        if (isGroupHierarchyRow(item as HierarchyItem)) {
          return groupRowCell;
        }
        const estimated = Number(item.estimatedBudget) || 0;
        const fbv =
          item.forecastBudgetVariance !== undefined && item.forecastBudgetVariance !== null
            ? Math.round(Number(item.forecastBudgetVariance))
            : estimated > 0 && item.reCalculateBudget != null && Number(item.reCalculateBudget) > 0
            ? Math.round(((Number(item.reCalculateBudget) - estimated) / estimated) * 100)
            : null;

        if (fbv === null || isNaN(fbv)) {
          return <span className="text-slate-400 font-medium">N/A</span>;
        }

        const org = getCurrentUserOrganisation(user)?.organisation;
        const onBudgetMax = org?.onBudgetMax ?? 5;
        const moderateBudgetMax = org?.moderateBudgetMax ?? 20;

        let colorClass = "text-[#535EF9]";
        if (fbv <= 0) {
          colorClass = "text-[#22C55E]";
        } else if (fbv <= onBudgetMax) {
          colorClass = "text-[#535EF9]";
        } else if (fbv <= moderateBudgetMax) {
          colorClass = "text-[#FAB415]";
        } else {
          colorClass = "text-[#EF4444]";
        }

        return (
          <div className="flex gap-1 items-center font-semibold text-slate-700">
            <span className={colorClass}>
              {fbv > 0 ? `+${fbv}%` : `${fbv}%`}
            </span>
          </div>
        );
      },
      onHeaderRender: (item: string) => (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger className="flex gap-1 items-center w-fit uppercase">
              <span className="uppercase">{t(item)}</span>
              <img
                src={InfoProgressCircle}
                className="min-w-4 w-4"
                alt="InfoCircle"
              />
            </TooltipTrigger>
              <TooltipContent className="z-50 normal-case p-0 bg-white border border-slate-200 shadow-xl rounded-xl" sideOffset={30}>
                <ForecastBudgetVarianceTooltipContent />
              </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      ),
    },
    {
      key: "startDate",
      header: t("estimated_start_date"),
      sorting: true,
      width: 132,
      onCellRender: (item: HierarchyItem) =>
        item.type === "project" ? (
          <div className="text-base font-medium whitespace-nowrap tabular-nums">
            {dateFormatter(new Date(item.startDate))}
          </div>
        ) : (
          groupRowCell
        ),
    },
    {
      key: "actualEndDate",
      header: t("actual_date"),
      sorting: true,
      width: 120,
      onCellRender: (item: HierarchyItem) =>
        item.type === "project" ? (
          <>
            {item.actualEndDate ? (
              <div className="text-base font-medium whitespace-nowrap tabular-nums">
                {dateFormatter(new Date(item.actualEndDate))}
              </div>
            ) : (
              <div className="text-base font-medium whitespace-nowrap">N/A</div>
            )}
          </>
        ) : (
          groupRowCell
        ),
    },
    {
      key: "estimatedEndDate",
      header: t("estimated_end_date"),
      sorting: true,
      width: 132,
      onCellRender: (item: HierarchyItem) =>
        item.type === "project" ? (
          <>
            {item.estimatedEndDate ? (
              <div className="text-base font-medium whitespace-nowrap tabular-nums">
                {dateFormatter(new Date(item.estimatedEndDate))}
              </div>
            ) : (
              <div className="text-base font-medium whitespace-nowrap">N/A</div>
            )}
          </>
        ) : (
          groupRowCell
        ),
    },

    {
      key: "actualEndDateDashboard",
      header: t("actual_end_date"),
      sorting: false,
      width: 128,
      onCellRender: (item: HierarchyItem) => {
        if (isGroupHierarchyRow(item)) return groupRowCell;
        const p = item as Project;
        return (
          <>
            {p.actualEndDate ? (
              <div className="text-base font-medium whitespace-nowrap tabular-nums">
                {dateFormater(new Date(p.actualEndDate))}
              </div>
            ) : (
              <div className="text-base font-medium whitespace-nowrap">N/A</div>
            )}
          </>
        );
      },
    },
    {
      key: "recalCulatedEndDate",
      header: t("Re_calculated_end_date"),
      sorting: true,
      width: 148,
      onCellRender: (item: HierarchyItem) => {
        if (isGroupHierarchyRow(item)) return groupRowCell;
        const p = item as Project;
        return (
          <>
            {p.reCalculateEndDate ? (
              <div className="text-base font-medium whitespace-nowrap tabular-nums">
                {dateFormater(new Date(p.reCalculateEndDate))}
              </div>
            ) : (
              <div className="text-base font-medium whitespace-nowrap">N/A</div>
            )}
          </>
        );
      },
    },
    {
      key: "estimatedBudget",
      header: t("estimated_budget"),
      sorting: true,
      width: 128,
      onCellRender: (item: HierarchyItem) =>
        isGroupHierarchyRow(item) ? (
          groupRowCell
        ) : (
          <>
            {(item as Project).estimatedBudget !== undefined &&
              !isNaN(Number((item as Project).estimatedBudget))
              ? Math.round(Number((item as Project).estimatedBudget))
              : 0}
          </>
        ),
    },
    {
      key: "consumedBudget",
      header: t("consumed_budget"),
      sorting: true,
      width: 128,
      onCellRender: (item: HierarchyItem) =>
        isGroupHierarchyRow(item) ? (
          groupRowCell
        ) : (
          <>
            {(item as Project).consumedBudget !== undefined &&
              !isNaN(Number((item as Project).consumedBudget))
              ? Math.round(Number((item as Project).consumedBudget))
              : 0}
          </>
        ),
    },
    {
      key: "reCalculateBudget",
      header: t("Re_calculated_budget"),
      sorting: true,
      width: 140,
      onCellRender: (item: HierarchyItem) =>
        isGroupHierarchyRow(item) ? (
          groupRowCell
        ) : (
          <>
            {(item as Project).reCalculateBudget !== undefined &&
              !isNaN(Number((item as Project).reCalculateBudget))
              ? Math.round(Number((item as Project).reCalculateBudget))
              : 0}
          </>
        ),
    },
    {
      key: "projectCode",
      header: t("project_code"),
      sorting: true,
      hidden: true,
      width: 100,
      onCellRender: (item: HierarchyItem) =>
        item.type === "project" ? (
          <div className="text-sm">{(item as Project).projectCode ?? "N/A"}</div>
        ) : (
          groupRowCell
        ),
    },
    {
      key: "sponsor",
      header: t("Sponsor"),
      sorting: true,
      hidden: true,
      width: 120,
      onCellRender: (item: HierarchyItem) =>
        item.type === "project" ? (
          <div className="text-sm">{(item as Project).sponsor ?? "N/A"}</div>
        ) : (
          groupRowCell
        ),
    },
    {
      key: "clientDepartment",
      header: t("Client/Department"),
      sorting: true,
      hidden: true,
      width: 130,
      onCellRender: (item: HierarchyItem) =>
        item.type === "project" ? (
          <div className="text-sm">{(item as Project).clientDepartment ?? "N/A"}</div>
        ) : (
          groupRowCell
        ),
    },
    {
      key: "projectCategory",
      header: projectFieldLabels.categoryLabel,
      sorting: true,
      hidden: true,
      width: 130,
      onCellRender: (item: HierarchyItem) => {
        if (item.type !== "project") return groupRowCell;
        const p = item as unknown as Project;
        const val = p.projectCategory && typeof p.projectCategory === "object" ? p.projectCategory.categoryName : (p.projectCategory || "N/A");
        return <div className="text-sm">{val}</div>;
      },
    },
    {
      key: "updatedAt",
      header: t("last_update"),
      sorting: true,
      hidden: true,
      width: 130,
      onCellRender: (item: HierarchyItem) => {
        if (item.type !== "project") return groupRowCell;
        const p = item as unknown as Project;
        return p.updatedAt ? (
          <div className="text-sm whitespace-nowrap tabular-nums">{dateFormatter(new Date(p.updatedAt))}</div>
        ) : (
          <div className="text-sm">N/A</div>
        );
      },
    },
    {
      key: "projectPhase",
      header: projectFieldLabels.phaseLabel,
      sorting: true,
      hidden: true,
      width: 120,
      onCellRender: (item: HierarchyItem) => {
        if (item.type !== "project") return groupRowCell;
        const p = item as unknown as Project;
        const val = p.projectPhase && typeof p.projectPhase === "object" ? p.projectPhase.phaseName : (p.projectPhase || "N/A");
        return <div className="text-sm">{val}</div>;
      },
    },
    {
      key: "priority",
      header: projectFieldLabels.priorityLabel,
      sorting: true,
      hidden: true,
      width: 100,
      onCellRender: (item: HierarchyItem) => {
        if (item.type !== "project") return groupRowCell;
        const p = item as unknown as Project;
        const val = p.priority && typeof p.priority === "object" ? p.priority.priorityName : (p.priority || "N/A");
        return <div className="text-sm">{val}</div>;
      },
    },
    {
      key: "projectType",
      header: projectFieldLabels.typeLabel,
      sorting: true,
      hidden: true,
      width: 120,
      onCellRender: (item: HierarchyItem) => {
        if (item.type !== "project") return groupRowCell;
        const p = item as unknown as Project;
        const val = p.projectType && typeof p.projectType === "object" ? p.projectType.projectTypeName : (p.projectType || "N/A");
        return <div className="text-sm">{val}</div>;
      },
    },
    {
      key: "workstream",
      header: projectFieldLabels.workstreamLabel,
      sorting: true,
      hidden: true,
      width: 120,
      onCellRender: (item: HierarchyItem) => {
        if (item.type !== "project") return groupRowCell;
        const p = item as unknown as Project;
        const val = p.workstream && typeof p.workstream === "object" ? p.workstream.workstreamName : (p.workstream || "N/A");
        return <div className="text-sm">{val}</div>;
      },
    },
    {
      key: "tags",
      header: t("Tags"),
      sorting: false,
      hidden: true,
      width: 150,
      onCellRender: (item: HierarchyItem) => {
        if (item.type !== "project") return groupRowCell;
        const p = item as unknown as Project;
        const val = p.tags && Array.isArray(p.tags) ? p.tags.join(", ") : "N/A";
        return <div className="text-sm">{val}</div>;
      },
    },
    {
      key: "Action",
      header: t("actions"),
      width: 100,
      onCellRender: (item: HierarchyItem) => {
        if (item.type !== "project") return groupRowCell;

        const findUser = item?.assignedUsers?.find(
          (t: { user: { userId: string | undefined } }) =>
            t.user.userId == user?.userId,
        );

        const projectNode = item as ProjectNode;
        const canManageThisProject = Boolean(
          user &&
          canManageProjectTasksAndContent(
            user,
            getCurrentOrgRole(user, getCurrentUserOrganisation(user)?.organisationId),
            projectNode.assignedUsers,
            normalizeProjectScope(projectNode),
          ),
        );
        const canDuplicateOrRemoveThisProject = Boolean(
          user &&
          canDuplicateOrRemoveProject(
            user,
            getCurrentOrgRole(user, getCurrentUserOrganisation(user)?.organisationId),
            projectNode.assignedUsers,
            normalizeProjectScope(projectNode),
          ),
        );

        return (
          <>
            <DropdownMenu>
              <DropdownMenuTrigger
                asChild
                disabled={
                  !item.isActive ||
                  (findUser &&
                    findUser.projectRole == UserRoleEnumValue.COLLABORATOR &&
                    !canManageThisProject)
                }
                className={`${!item.isActive ||
                  (findUser &&
                    findUser.projectRole == UserRoleEnumValue.COLLABORATOR &&
                    !canManageThisProject)
                  ? "opacity-65"
                  : ""
                  }`}
              >
                <div
                  className={`cursor-pointer  px-3 py-1.5 bg-transparent justify-center items-center gap-px inline-flex ${!item.isActive ? "cursor-not-allowed" : ""
                    }`}
                >
                  <img src={NewEditIcon} className="mr-2 h-4 w-4" />
                </div>
              </DropdownMenuTrigger>
              <DropdownMenuContent className="w-fit flex flex-col gap-1">
                <DropdownMenuSeparator className="mx-1" />
                <DropdownMenuItem onClick={() => handleView(item.projectId)}>
                  <Settings className="mr-2 h-4 w-4 text-[#44546F]" />
                  <span className="p-0 font-normal h-auto">
                    {t("project_settings")}
                  </span>
                </DropdownMenuItem>
                <DropdownMenuItem
                  disabled={
                    findUser?.projectRole == UserRoleEnumValue.TEAM_MEMBER &&
                    !canManageThisProject
                  }
                  onClick={() => setProjectId(item.projectId)}
                >
                  <ScrollText className="mr-2 h-4 w-4 text-[#44546F]" />
                  <span className="p-0 font-normal h-auto">
                    {t("create_task")}
                  </span>
                </DropdownMenuItem>
                <DropdownMenuItem
                  onClick={() => {
                    if (canDuplicateOrRemoveThisProject) {
                      createDuplicate(item.projectId);
                    }
                  }}
                  disabled={!canDuplicateOrRemoveThisProject}
                  className={!canDuplicateOrRemoveThisProject ? "opacity-50 cursor-not-allowed" : ""}
                >
                  <img src={DuplicateIcon} className="h-4 w-4 mr-2" />
                  <span className="p-0 font-normal h-auto">
                    {t("duplicate_project")}
                  </span>
                </DropdownMenuItem>
                <DropdownMenuItem
                  onClick={() => navigate("/members/" + item.projectId)}
                >
                  <img src={Users} className="h-4 w-4 mr-2" />
                  <span className="p-0 font-normal h-auto">
                    {t("project_members")}
                  </span>
                </DropdownMenuItem>
                <DropdownMenuItem
                  onClick={() => {
                    if (canDuplicateOrRemoveThisProject) {
                      setRemove(item.projectId);
                    }
                  }}
                  disabled={!canDuplicateOrRemoveThisProject}
                  className={!canDuplicateOrRemoveThisProject ? "opacity-50 cursor-not-allowed" : ""}
                >
                  <img src={TrashCan} className="h-4 w-4 mr-2" />
                  <span className="p-0 font-normal h-auto text-red-500">
                    {t("remove_project")}
                  </span>
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </>
        );
      },
    },
  ];

  const columnDef: ColumeDef[] = isAdmin ? [
    {
      key: "selection",
      header: " ",
      width: 40,
      onHeaderRender: () => (
        <div className="flex items-center justify-center w-full header-checkbox-container">
          <label className="relative flex cursor-pointer items-center justify-center p-1">
            <input 
              type="checkbox"
              className="peer sr-only"
              checked={
                visibleProjectIds.length > 0 && 
                selectedProjectIds.size === visibleProjectIds.length
              }
              onChange={(e) => handleSelectAll(e.target.checked)}
              aria-label={t("select_all")}
            />
            <div className="h-5 w-5 rounded-md border-[1.5px] border-gray-300 bg-white transition-all duration-200 peer-checked:border-primary peer-checked:bg-primary peer-hover:border-primary/70 flex items-center justify-center shadow-sm text-transparent peer-checked:text-white [&_svg]:scale-50 peer-checked:[&_svg]:scale-100 [&_svg]:transition-transform">
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="3">
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </div>
          </label>
        </div>
      ),
      onCellRender: (item: HierarchyItem) => {
        if (item.type !== "project") return <></>;
        const isSelected = selectedProjectIds.has(item.projectId);
        return (
          <div className={`flex items-center justify-center w-full row-checkbox-container ${isSelected ? 'is-checked' : ''}`} onClick={(e) => e.stopPropagation()}>
            <label className="relative flex cursor-pointer items-center justify-center p-1">
              <input 
                type="checkbox"
                className="peer sr-only"
                checked={selectedProjectIds.has(item.projectId)}
                onChange={(e) => handleSelectRow(item.projectId, e.target.checked)}
                aria-label={t("select_all")}
              />
              <div className="h-5 w-5 rounded-md border-[1.5px] border-gray-300 bg-white transition-all duration-200 peer-checked:border-primary peer-checked:bg-primary peer-hover:border-primary/70 flex items-center justify-center shadow-sm text-transparent peer-checked:text-white [&_svg]:scale-50 peer-checked:[&_svg]:scale-100 [&_svg]:transition-transform">
                <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="3">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </div>
            </label>
          </div>
        );
      }
    },
    ...baseColumnDef
  ] : baseColumnDef;

  const getStatusColor = (status: string) => {
    switch (status) {
      case ProjectStatusEnumValue.NOT_STARTED:
        return "bg-[#FF8C00]/20 text-[#FF8C09]";
      case ProjectStatusEnumValue.ON_HOLD:
        return "bg-[#FAB415]/20 text-[#B58109]";
      case ProjectStatusEnumValue.ACTIVE:
      case ProjectStatusEnumValue.IN_PROGRESS:
        return "bg-[#53C36C]/20 text-[#15803D]";
      case ProjectStatusEnumValue.CLOSED:
      case ProjectStatusEnumValue.COMPLETED:
        return "bg-[#828F9B]/20 text-[#828F89]";
      case ProjectStatusEnumValue.CANCELLED:
        return "bg-[#EF4444]/20 text-[#DC2626]";
    }
  };

  const removeProject = () => {
    removeProjectMutation.mutate(remove ?? "", {
      onSuccess(data) {
        toast.success(errorKeyFormate(data?.data?.message || "project_deleted_successfully"));
        queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.getProjects] });
        queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.getProjectsNocal] });
        queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.portfolioDashboard] });
        setRemove(undefined);
      },
      onError(error) {
        toast.error(errorKeyFormate(error.response?.data.message + ""));
      },
    });
  };

  const removeProgramMutation = useRemoveProgramMutation();
  const removePortfolioMutation = useRemovePortfolioMutation();
  const handleRemovePortfolioAndProgram = () => {
    if (deletePortfolioAndProgram?.portfolio) {
      removePortfolioMutation.mutate(deletePortfolioAndProgram?.portfolio, {
        onSuccess() {
          toast.success(t("Portfolio deleted successfully"));
          queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.getProjects] });
          queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.getProjectsNocal] });
          projectQuery.refetch().then(() => {
            setDeletePortfolioAndProgram(undefined);
            projectQuery.refetch();
          });
        },
        onError(error) {
          toast.error(
            errorKeyFormate(error.response?.data.message ?? ""),
            errorConfig,
          );
        },
      });
    }
    if (deletePortfolioAndProgram?.program) {
      removeProgramMutation.mutate(deletePortfolioAndProgram?.program, {
        onSuccess() {
          toast.success(t("Program deleted successfully"));
          queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.getProjects] });
          queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.getProjectsNocal] });
          projectQuery.refetch().then(() => {
            setDeletePortfolioAndProgram(undefined);
            projectQuery.refetch();
          });
        },
        onError(error) {
          toast.error(
            errorKeyFormate(error.response?.data.message ?? ""),
            errorConfig,
          );
        },
      });
    }
  };
  const innerTable = (data: any, level = 0) => {
    return (
      <div className="w-full min-w-0">
        <Table
          expandAll={Boolean(searchParams.size) || isExpand}
          key="Project view"
          hideHeaders={true}
          tableClassName={`${projectsListTableClassName} !shadow-none`}
          columnDef={
            columnDef?.map((d) => {
              return {
                ...d,
                className: () => {
                  const isDateCol = projectsListDateColumnKeys.includes(d.key);
                  const pad = isDateCol ? "px-3 py-2.5" : "px-3 py-2.5";
                  if (level == 0) {
                    return `${d.key === "Action" ? "rounded-e-xl" : ""} ${d.key === "projectName" ? "!max-w-96" : ""
                      } ${pad} align-middle`.trim();
                  }
                  const levelIndent = d.key === "projectName"
                    ? (level === 1 ? "!pl-8" : level === 2 ? "!pl-14" : "!pl-20")
                    : "";
                  return `${pad} align-middle ${levelIndent}`.trim();
                },
              };
            }) ?? []
          }
          className="border-0 !px-0 !rounded-none [&>*]:!overflow-hidden"
          data={[
            ...(Array.isArray(data.programs) ? data.programs : []),
            ...(Array.isArray(data.projects) ? data.projects : []),
          ]}
          onAccordionRender={(data) =>
            [
              ...(Array.isArray(data.programs) ? data.programs : []),
              ...(Array.isArray(data.projects) ? data.projects : []),
            ].length > 0 ? (
              innerTable(data, level + 1)
            ) : (
              <></>
            )
          }
          onRowClassName={(data) => {
            return `row-action-hover-group group ${data.type === "project" && !data.isActive
              ? "opacity-70 cursor-not-allowed  "
              : ""
              } ${data.type === "portfolio"
                ? "!bg-secondary/20 !border-none "
                : ""
              }  border-b  ${data.type === "program" ? "!bg-secondary/10 !border-none " : ""
              }`;
          }}
          showDropDown={(data) => {
            return `${data.type === "project" ? "opacity-0 !pl-0" : ""
              } !pl-0 !rounded-s-xl`;
          }}
          showDropDownImg={() => {
            return "!block";
          }}
          hidePagination={true}
          notShowNoDataFound={true}
        />
      </div>
    );
  };
  const [isOpenWorkLoad, setIsOpenWorkLoad] = useState(false);
  const downloadExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Projects");

    worksheet.columns = [
      { header: "Portfolio", key: "portfolio", width: 25 },
      { header: "Program", key: "program", width: 25 },
      { header: "Project", key: "project", width: 25 },
      { header: "Project Code", key: "projectCode", width: 20 },
      { header: "Start Date (dd/mm/yyyy)", key: "startDate", width: 25 },
      { header: "Estimated End Date (dd/mm/yyyy)", key: "estimatedEndDate", width: 25 },
      { header: "Description", key: "description", width: 35 },
      { header: "Estimate budget", key: "estimatedBudget", width: 20 },
      { header: "Currency", key: "currency", width: 15 },
      { header: "Client Department", key: "clientDepartment", width: 25 },
      { header: projectFieldLabels.typeLabel, key: "projectType", width: 20 },
      { header: projectFieldLabels.phaseLabel, key: "projectPhase", width: 20 },
      { header: projectFieldLabels.priorityLabel, key: "priority", width: 15 },
      { header: projectFieldLabels.categoryLabel, key: "category", width: 20 },
      { header: projectFieldLabels.workstreamLabel, key: "workstream", width: 20 },
      { header: "Actual Progress", key: "actualProgress", width: 18 },
      { header: "Expected Progress", key: "expectedProgress", width: 18 },
      { header: "Status", key: "status", width: 18 },
      { header: "SPI", key: "spi", width: 12 },
      { header: "Budget Variance", key: "budgetVariance", width: 20 },
      { header: "Actual Start Date (dd/mm/yyyy)", key: "actualStartDate", width: 25 },
      { header: "Actual End Date (dd/mm/yyyy)", key: "actualEndDate", width: 25 },
      { header: "Re-calculated End Date (dd/mm/yyyy)", key: "reCalculatedEndDate", width: 28 },
      { header: "Consumed budget", key: "consumedBudget", width: 20 },
      { header: "Recalculated Budget", key: "reCalculatedBudget", width: 22 },
    ];

    const projectSorted = [
      ...(data?.filter((p: any) => !p.portfolio && !p.program) ?? []),
      ...(data?.filter((p: any) => p.portfolio || p.program) ?? []),
    ];

    projectSorted.forEach((p: any) => {
      const actualRaw = Number(p.progressionPercentage ?? 0) * 100;
      const actualProgress = Math.round(actualRaw);
      const spi = Number(p.spi ?? 0);
      const expectedProgress = Math.min(
        spi > 0 ? Math.round(actualRaw / (spi / 100)) : actualProgress,
        100
      );

      const statusFormatted = p.status
        ? p.status
            .toLowerCase()
            .replace(/_/g, " ")
            .replace(/\b\w/g, (c: string) => c.toUpperCase())
        : "";

      let budgetVariance = "N/A";
      if (p.forecastBudgetVariance !== undefined && p.forecastBudgetVariance !== null) {
        const val = Math.round(Number(p.forecastBudgetVariance));
        budgetVariance = `${val > 0 ? "+" : ""}${val}%`;
      } else if (
        p.estimatedBudget &&
        Number(p.estimatedBudget) > 0 &&
        p.reCalculateBudget != null &&
        Number(p.reCalculateBudget) > 0
      ) {
        const val = Math.round(
          ((Number(p.reCalculateBudget) - Number(p.estimatedBudget)) /
            Number(p.estimatedBudget)) *
            100
        );
        budgetVariance = `${val > 0 ? "+" : ""}${val}%`;
      }

      const pType =
        typeof p.projectType === "object" && p.projectType !== null
          ? p.projectType.projectTypeName || p.projectType.name || ""
          : (p.projectType ?? "");

      const pPhase =
        typeof p.projectPhase === "object" && p.projectPhase !== null
          ? p.projectPhase.phaseName || p.projectPhase.name || ""
          : (p.projectPhase ?? "");

      const pPriority =
        typeof p.priority === "object" && p.priority !== null
          ? p.priority.priorityName || p.priority.name || ""
          : (p.priority ?? "");

      const pCategory =
        typeof p.projectCategory === "object" && p.projectCategory !== null
          ? p.projectCategory.categoryName || p.projectCategory.name || ""
          : (p.projectCategory ?? "");

      const pWorkstream =
        typeof p.workstream === "object" && p.workstream !== null
          ? p.workstream.workstreamName || p.workstream.name || ""
          : (p.workstream ?? "");

      worksheet.addRow({
        portfolio: p.portfolio?.portfolioName ?? "",
        program: p.program?.programName ?? "",
        project: p.projectName ?? "",
        projectCode: p.projectCode ?? "",
        startDate: p.startDate ? dateFormater(new Date(p.startDate)) : "",
        estimatedEndDate: p.estimatedEndDate ? dateFormater(new Date(p.estimatedEndDate)) : "",
        description: p.projectDescription ?? "",
        estimatedBudget: p.estimatedBudget ?? "",
        currency: p.currency ?? "",
        clientDepartment: p.clientDepartment ?? "",
        projectType: pType,
        projectPhase: pPhase,
        priority: pPriority,
        category: pCategory,
        workstream: pWorkstream,
        actualProgress: `${actualProgress}%`,
        expectedProgress: `${expectedProgress}%`,
        status: statusFormatted,
        spi: `${Math.round(spi)}%`,
        budgetVariance: budgetVariance,
        actualStartDate: (p.projectActualStartDate || p.actualStartDate)
          ? dateFormater(new Date(String(p.projectActualStartDate || p.actualStartDate)))
          : "N/A",
        actualEndDate: p.actualEndDate
          ? dateFormater(new Date(String(p.actualEndDate)))
          : "N/A",
        reCalculatedEndDate: p.reCalculateEndDate
          ? dateFormater(new Date(String(p.reCalculateEndDate)))
          : "N/A",
        consumedBudget: p.consumedBudget ?? "",
        reCalculatedBudget:
          p.reCalculateBudget != null
            ? Math.round(Number(p.reCalculateBudget))
            : 0,
      });
    });

    // Style headers with import template blue header
    const headerRow = worksheet.getRow(1);
    headerRow.eachCell({ includeEmpty: true }, (cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF535EF9" },
      };
      cell.font = {
        color: { argb: "FFFFFFFF" },
        bold: true,
      };
      cell.alignment = { vertical: "middle", horizontal: "center" };
    });

    // Format date column cells as text to keep dd/mm/yyyy display
    for (let i = 2; i <= worksheet.rowCount; i++) {
      worksheet.getCell(`E${i}`).numFmt = "@";
      worksheet.getCell(`F${i}`).numFmt = "@";
      worksheet.getCell(`U${i}`).numFmt = "@";
      worksheet.getCell(`V${i}`).numFmt = "@";
      worksheet.getCell(`W${i}`).numFmt = "@";
    }

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `portfolio.xlsx`;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const downloadProjectImportTemplate = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Hierarchy Import Template");

    const cleanForFormula = (names: string[], defaultFallback: string) => {
      if (!names || names.length === 0) return defaultFallback;
      const list = names
        .map(name => name?.replace(/[",]/g, "").trim())
        .filter(Boolean);
      if (list.length === 0) return defaultFallback;
      const joined = list.join(",");
      return joined.length > 250 ? joined.substring(0, 250) : joined;
    };

    const typeOptions = cleanForFormula(
      projectTypesQuery.data?.data.data.map((item: any) => item.projectTypeName || item.name) || [],
      "Internal,External"
    );

    const phaseOptions = cleanForFormula(
      projectPhasesQuery.data?.data.data.map((item: any) => item.phaseName || item.name) || [],
      "Discovery,Execution,Closure"
    );

    const priorityOptions = cleanForFormula(
      projectPrioritiesQuery.data?.data.data.map((item: any) => item.priorityName || item.name) || [],
      "Low,Medium,High,Critical"
    );

    const categoryOptions = cleanForFormula(
      projectCategoriesQuery.data?.data.data.map((item: any) => item.categoryName || item.name) || [],
      "Software,Infrastructure,Marketing"
    );

    const workstreamOptions = cleanForFormula(
      workstreamsQuery.data?.data.data.map((item: any) => item.workstreamName || item.name) || [],
      "General,Development,Marketing,Operations"
    );

    const firstType = projectTypesQuery.data?.data.data?.[0]?.projectTypeName || projectTypesQuery.data?.data.data?.[0]?.name || "Projet interne";
    const firstPhase = projectPhasesQuery.data?.data.data?.[0]?.phaseName || projectPhasesQuery.data?.data.data?.[0]?.name || "Discovery";
    const firstPriority = projectPrioritiesQuery.data?.data.data?.[0]?.priorityName || projectPrioritiesQuery.data?.data.data?.[0]?.name || "High";
    const firstCategory = projectCategoriesQuery.data?.data.data?.[0]?.categoryName || projectCategoriesQuery.data?.data.data?.[0]?.name || "Infrastructure";
    const firstWorkstream = workstreamsQuery.data?.data.data?.[0]?.workstreamName || workstreamsQuery.data?.data.data?.[0]?.name || "General";

    const userOrgCountry = getCurrentUserOrganisation(user)?.organisation?.country;
    const defaultCurrency = (countries.find(
      (c) => c.isoCode?.toUpperCase() === userOrgCountry?.toUpperCase() || c.name?.toUpperCase() === userOrgCountry?.toUpperCase()
    )?.currency || "USD").toUpperCase();

    worksheet.columns = [
      { header: "Portfolio", key: "portfolio", width: 25 },
      { header: "Program", key: "program", width: 25 },
      { header: "Project", key: "project", width: 25 },
      { header: "Project Code", key: "projectCode", width: 20 },
      { header: "Start Date (dd/mm/yyyy)", key: "startDate", width: 25 },
      { header: "Estimated End Date (dd/mm/yyyy)", key: "estimatedEndDate", width: 25 },
      { header: "Description", key: "description", width: 35 },
      { header: "Estimate budget", key: "estimatedBudget", width: 20 },
      { header: "Currency", key: "currency", width: 15 },
      { header: "Client Department", key: "clientDepartment", width: 25 },
      { header: projectFieldLabels.typeLabel, key: "projectType", width: 20 },
      { header: projectFieldLabels.phaseLabel, key: "projectPhase", width: 20 },
      { header: projectFieldLabels.priorityLabel, key: "priority", width: 15 },
      { header: projectFieldLabels.categoryLabel, key: "category", width: 20 },
      { header: projectFieldLabels.workstreamLabel, key: "workstream", width: 20 },
    ];

    // Add some sample helper data rows
    worksheet.addRow({
      portfolio: "IT Portfolio",
      program: "Cloud Migration",
      project: "Auth Service Migration",
      projectCode: "PRJ-001",
      startDate: "15/09/2026",
      estimatedEndDate: "31/12/2026",
      description: "Migrate microservice authorization",
      estimatedBudget: "50000",
      currency: defaultCurrency,
      clientDepartment: "Engineering",
      projectType: firstType,
      projectPhase: firstPhase,
      priority: firstPriority,
      category: firstCategory,
      workstream: firstWorkstream,
    });

    worksheet.addRow({
      portfolio: "",
      program: "",
      project: "Core Database Update",
      projectCode: "PRJ-002",
      startDate: "01/10/2026",
      estimatedEndDate: "15/12/2026",
      description: "Upgrade database clusters",
      estimatedBudget: "75000",
      currency: defaultCurrency,
      clientDepartment: "IT Operations",
      projectType: firstType,
      projectPhase: firstPhase,
      priority: firstPriority,
      category: firstCategory,
      workstream: firstWorkstream,
    });

    worksheet.addRow({
      portfolio: "",
      program: "HR Integration",
      project: "Payroll Sync",
      projectCode: "PRJ-003",
      startDate: "10/10/2026",
      estimatedEndDate: "30/11/2026",
      description: "Sync payroll database",
      estimatedBudget: "20000",
      currency: defaultCurrency,
      clientDepartment: "Human Resources",
      projectType: firstType,
      projectPhase: firstPhase,
      priority: firstPriority,
      category: firstCategory,
      workstream: firstWorkstream,
    });

    // Style headers
    const headerRow = worksheet.getRow(1);
    headerRow.eachCell({ includeEmpty: true }, (cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF535EF9" },
      };
      cell.font = {
        color: { argb: "FFFFFFFF" },
        bold: true,
      };
      cell.alignment = { vertical: "middle", horizontal: "center" };
    });

    // Format date column cells and add data validations
    for (let i = 2; i <= 1000; i++) {
      worksheet.getCell(`E${i}`).numFmt = "@";
      worksheet.getCell(`F${i}`).numFmt = "@";

      worksheet.getCell(`K${i}`).dataValidation = {
        type: "list",
        allowBlank: true,
        formulae: [`"${typeOptions}"`],
      };
      worksheet.getCell(`L${i}`).dataValidation = {
        type: "list",
        allowBlank: true,
        formulae: [`"${phaseOptions}"`],
      };
      worksheet.getCell(`M${i}`).dataValidation = {
        type: "list",
        allowBlank: true,
        formulae: [`"${priorityOptions}"`],
      };
      worksheet.getCell(`N${i}`).dataValidation = {
        type: "list",
        allowBlank: true,
        formulae: [`"${categoryOptions}"`],
      };
      worksheet.getCell(`O${i}`).dataValidation = {
        type: "list",
        allowBlank: true,
        formulae: [`"${workstreamOptions}"`],
      };
    }

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `project_hierarchy_import_template.xlsx`;
    a.click();
    window.URL.revokeObjectURL(url);
  };


  const [isExpand, setIsExpand] = useState(Boolean(searchParams.size) ?? true);
  const [filterUnit, setFilterUnit] = useState(1);
  const [selectedDateType, setSelectedDateType] = useState<
    "estimated" | "actual"
  >(() => {
    const compareParam = searchParams.get("compare");
    return compareParam === "actualToReCalculated" ? "actual" : "estimated";
  });
  const [compare, setCompare] = useState<
    "estimatedToActual" | "actualToReCalculated" | "all" | ""
  >(() => {
    const compareParam = searchParams.get("compare");
    if (
      compareParam === "estimatedToActual" ||
      compareParam === "actualToReCalculated" ||
      compareParam === "all"
    ) {
      return compareParam;
    }
    return "";
  });
  const options = [
    {
      label: t("Estimated Dates"),
      value: "estimated",
      tooltip: t("Estimated dates tooltip"),
    },
    {
      label: t("Current Dates"),
      value: "actual",
      tooltip: t("Current dates tooltip"),
    },
  ];
  const [isShowVideo, setIsShowVideo] = useState(false);

  // Remaining JSX of your component is here...
  // ... No changes needed for the rest of the file
  const navigtae = useNavigate();
  const toggleWorkload = () => {
    if (
      !user?.subscription ||
      !user?.subscription?.planType ||
      user?.subscription?.planType == PlanTypeEnumSchema.FREE
    ) {
      navigtae("/plans");
    } else {
      setIsOpenWorkLoad(!isOpenWorkLoad);
    }
  };
  const rawProjects = projectQuery.data?.data?.data?.projects;
  const hasZeroProjects = projectQuery.isSuccess && Array.isArray(rawProjects) && rawProjects.length === 0;
  if (projectQuery.isFetched && hasZeroProjects && !searchParams.get("overall")) {
    return (
      <>
        <NoProject onImportClick={() => setIsImportOpen(true)} onDownloadTemplate={downloadProjectImportTemplate} />
        {isImportOpen && (
          <HierarchyImportModal
            isOpen={isImportOpen}
            onClose={() => setIsImportOpen(false)}
            onSuccess={() => projectQuery.refetch()}
            downloadTemplate={downloadProjectImportTemplate}
          />
        )}
      </>
    );
  }
  return (
    <div
      className="relative flex h-full min-h-0 w-full flex-col overflow-hidden"
      ref={fullScreen}
    >

      <>
        <div className="flex h-full min-h-0 w-full flex-1 flex-col gap-2 overflow-hidden px-2 pt-2 pb-0">
          <div className="flex w-full shrink-0 items-center justify-between">
            <div className="flex gap-2 items-end">
              <ProjectFilter
                key={searchParams.size}
                project={data}
                fieldToShow={[
                  FIELDS.STATUS,
                  FIELDS.DELAY,
                  FIELDS.DATE,
                  FIELDS.BUDGET,
                ]} // adjust as needed
                filteredData={(data) => setFilterData(data || [])}
                appleed={() => {
                  if (filterData) {
                    setLoader(false);
                  }
                }}
              />
              {isAdmin && selectedProjectIds.size > 0 && (
                <Button
                  variant={"destructive"}
                  className="w-fit flex gap-1 text-white shadow-[0_4px_12px_-2px_rgba(239,68,68,0.3)] border-0"
                  size={"sm"}
                  onClick={() => setShowBulkDeleteDialog(true)}
                >
                  <img
                    src={TrashCan}
                    className="w-4 h-4 brightness-0 invert"
                  />
                  {t("bulk_delete")} ({selectedProjectIds.size})
                </Button>
              )}
              <Button
                variant={"primary"}
                className="w-fit flex gap-1 ml-full text-white !bg-gradient-to-r !from-[#535EF9] !to-[#3B82F6] hover:!from-[#535EF9]/90 hover:!to-[#3B82F6]/90 shadow-[0_4px_12px_-2px_rgba(83,94,249,0.3)] border-0"
                size={"sm"}
                onClick={handleOpenPopUp}
                disabled={
                  !(
                    user?.userOrganisation?.some(org => org.role === UserRoleEnumValue.ADMINISTRATOR || org.role === UserRoleEnumValue.PROJECT_MANAGER) ||
                    (user?.managedPortfolioIds &&
                      user.managedPortfolioIds.length > 0) ||
                    (user?.managedProgramIds &&
                      user.managedProgramIds.length > 0) ||
                    (user?.managedProjectIds &&
                      user.managedProjectIds.length > 0)
                  )
                }
              >
                <img
                  src={Plus}
                  className="w-3 min-w-3 brightness-0 invert "
                />
                {t("add_project")}
              </Button>
            </div>
            {view == ProjectDefaultViewEnumValue.GANTT && (
              <Button
                variant={"link"}
                onClick={() => setIsShowVideo(true)}
                className="text-secondary underline underline-offset-2 text-sm ml-auto h-fit !p-0 mr-2 "
              >
                {t("Check the video")}
              </Button>
            )}
            <div className="flex items-center justify-around gap-1 bg-[#F3F4F6] rounded-full px-2 py-1 w-fit">
              {viewOption?.map((item) => {
                return (
                  <TooltipProvider key={item.value}>
                    <Tooltip delayDuration={0}>
                      <TooltipTrigger asChild>
                        <div className="flex-1">
                          <button
                            className={`text-gra rounded-full min-w-14 relative flex items-center justify-center px-3 py-[0.6rem] h-fit gap-2 text-sm text-nowrap ${item.value == view
                              ? "bg-orange text-white"
                              : "bg-[#F3F4F6] text-[#565D6D]"
                              }`}
                            onClick={() => {
                              setView(item.value);
                            }}
                          >
                            <img src={item.icon} className={`w-4 min-w-4 ${item.value == view ? "brightness-0 invert" : "grayscale brightness-0"}`} />
                            {t(
                              item.value == ProjectDefaultViewEnumValue.GANTT
                                ? "roadmap_view"
                                : "List View",
                            )}
                          </button>
                        </div>
                      </TooltipTrigger>
                      <TooltipContent>
                        <p className="text-sm">
                          {t(
                            item.value == ProjectDefaultViewEnumValue.GANTT
                              ? "roadmap_view"
                              : "List View",
                          )}
                        </p>
                      </TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                );
              })}
            </div>
          </div>

          <div className="flex w-full shrink-0 flex-nowrap items-center justify-between gap-3 px-2 py-1.5 border-b border-gray-100 bg-white overflow-x-auto no-scrollbar min-h-[48px]">
            {/* Left Tools: Navigation + Actions + Filters */}
            <div className="flex items-center gap-2 shrink-0">
              {/* Unified Navigation & Actions Pill */}
              <div className="inline-flex items-center bg-gray-50/90 border border-gray-200/80 rounded-lg p-1 shadow-xs gap-0.5">
                {/* Expand / Collapse */}
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <button
                        type="button"
                        onClick={() => setIsExpand(!isExpand)}
                        className="h-8 w-8 flex items-center justify-center rounded-md hover:bg-white hover:shadow-xs text-gray-600 hover:text-gray-900 transition-all cursor-pointer select-none"
                      >
                        <img
                          src={!isExpand ? Collaps : Expand}
                          alt=""
                          className="w-4 min-w-4"
                        />
                      </button>
                    </TooltipTrigger>
                    <TooltipContent className="bg-white rounded-md px-2 py-1.5 shadow-lg border border-gray-450/30">
                      <p className="text-sm">
                        {t(!isExpand ? "expand" : "collapse")}
                      </p>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>

                {/* Zoom In & Out (Gantt only) */}
                {view == ProjectDefaultViewEnumValue.GANTT && (
                  <>
                    <div className="w-px h-4 bg-gray-200 mx-1" />
                    <TooltipProvider>
                      <Tooltip>
                        <TooltipTrigger asChild>
                          <button
                            type="button"
                            disabled={filterUnit == 0}
                            onClick={() =>
                              setFilterUnit((prev) => prev - 1)
                            }
                            className="h-8 w-8 flex items-center justify-center rounded-md hover:bg-white hover:shadow-xs text-gray-600 hover:text-gray-900 disabled:opacity-30 disabled:pointer-events-none transition-all cursor-pointer select-none"
                          >
                            <img src={ZoomIn} className="w-4 min-w-4" />
                          </button>
                        </TooltipTrigger>
                        <TooltipContent>
                          <p className="text-sm">{t("zoomin")}</p>
                        </TooltipContent>
                      </Tooltip>
                    </TooltipProvider>

                    <TooltipProvider>
                      <Tooltip>
                        <TooltipTrigger asChild>
                          <button
                            type="button"
                            disabled={filterUnit == 4}
                            onClick={() =>
                              setFilterUnit((prev) => prev + 1)
                            }
                            className="h-8 w-8 flex items-center justify-center rounded-md hover:bg-white hover:shadow-xs text-gray-600 hover:text-gray-900 disabled:opacity-30 disabled:pointer-events-none transition-all cursor-pointer select-none"
                          >
                            <img src={ZoomOut} className="w-4 min-w-4" />
                          </button>
                        </TooltipTrigger>
                        <TooltipContent>
                          <p className="text-sm">{t("zoomout")}</p>
                        </TooltipContent>
                      </Tooltip>
                    </TooltipProvider>
                  </>
                )}

                <div className="w-px h-4 bg-gray-200 mx-1" />

                {/* Fullscreen */}
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <button
                        type="button"
                        onClick={() => enterFullscreen()}
                        className="h-8 w-8 flex items-center justify-center rounded-md hover:bg-white hover:shadow-xs text-gray-600 hover:text-gray-900 transition-all cursor-pointer select-none"
                      >
                        <img
                          src={
                            !isFullscreen ? FullScreen : ExitFullscreen
                          }
                          className="w-4 min-w-4"
                        />
                      </button>
                    </TooltipTrigger>
                    <TooltipContent className="bg-white rounded-md px-2 py-1.5 shadow-lg border border-gray-450/30">
                      <p className="text-sm">
                        {t(
                          !isFullscreen
                            ? "full_Screen"
                            : "full_exit_screen",
                        )}
                      </p>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>

                {/* Refresh */}
                <TooltipProvider>
                  <Tooltip delayDuration={0}>
                    <TooltipTrigger asChild>
                      <button
                        type="button"
                        onClick={() => projectQuery.refetch()}
                        className="h-8 w-8 flex items-center justify-center rounded-md hover:bg-white hover:shadow-xs text-gray-600 hover:text-gray-900 transition-all cursor-pointer select-none"
                      >
                        <img src={Refresh} className="w-4 min-w-4" />
                      </button>
                    </TooltipTrigger>
                    <TooltipContent className="bg-white rounded-md px-2 py-1.5 shadow-lg border border-gray-450/30">
                      <p className="text-sm">{t("reload")}</p>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>

                <div className="w-px h-4 bg-gray-200 mx-1" />

                {/* Export to Excel */}
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <button
                        type="button"
                        onClick={() => downloadExcel()}
                        className="h-8 w-8 flex items-center justify-center rounded-md hover:bg-white hover:shadow-xs text-gray-600 hover:text-gray-900 transition-all cursor-pointer select-none"
                      >
                        <img src={DownLoadIcon} className="w-4 min-w-4" />
                      </button>
                    </TooltipTrigger>
                    <TooltipContent>
                      <p className="text-sm">{t("export_to_excel")}</p>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>

                {/* Import Projects Dropdown (Administrator & Managers) */}
                {(user?.userOrganisation?.some(org => org.role === UserRoleEnumValue.ADMINISTRATOR || org.role === UserRoleEnumValue.PROJECT_MANAGER) ||
                  (user?.managedPortfolioIds && user.managedPortfolioIds.length > 0) ||
                  (user?.managedProgramIds && user.managedProgramIds.length > 0) ||
                  (user?.managedProjectIds && user.managedProjectIds.length > 0)) && (
                  <DropdownMenu>
                    <TooltipProvider>
                      <Tooltip>
                        <TooltipTrigger asChild>
                          <DropdownMenuTrigger asChild>
                            <button
                              type="button"
                              className="h-8 w-8 flex items-center justify-center rounded-md hover:bg-white hover:shadow-xs text-gray-600 hover:text-gray-900 transition-all cursor-pointer select-none"
                            >
                              <img src={UploadIcon} className="w-4 min-w-4" />
                            </button>
                          </DropdownMenuTrigger>
                        </TooltipTrigger>
                        <TooltipContent>
                          <p className="text-sm">{t("import_projects")}</p>
                        </TooltipContent>
                      </Tooltip>
                    </TooltipProvider>
                    <DropdownMenuContent align="start" className="w-48 bg-white shadow-lg rounded-lg p-1 border border-gray-200/80 z-50">
                      <DropdownMenuItem
                        onClick={() => setIsImportOpen(true)}
                        className="cursor-pointer text-xs flex items-center gap-2.5 py-2 px-2.5 hover:bg-gray-100/80 rounded-md font-medium text-gray-700 transition-colors"
                      >
                        <img src={UploadIcon} className="w-4 h-4" />
                        <span>{t("import_project")}</span>
                      </DropdownMenuItem>
                      <DropdownMenuItem
                        onClick={downloadProjectImportTemplate}
                        className="cursor-pointer text-xs flex items-center gap-2.5 py-2 px-2.5 hover:bg-gray-100/80 rounded-md font-medium text-gray-700 transition-colors"
                      >
                        <img src={DownLoadIcon} className="w-4 h-4" />
                        <span>{t("download_template")}</span>
                      </DropdownMenuItem>
                    </DropdownMenuContent>
                  </DropdownMenu>
                )}
              </div>

              {/* Display Options: Milestone toggle (Roadmap view only) */}
              {view === ProjectDefaultViewEnumValue.GANTT && (
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <label className="inline-flex items-center gap-2 px-3 h-10 bg-gray-50/90 hover:bg-gray-100/80 border border-gray-200/80 rounded-lg text-xs font-medium text-gray-700 cursor-pointer select-none transition-all shadow-xs shrink-0">
                        <input
                          type="checkbox"
                          checked={showMilestones}
                          onChange={(e) => setShowMilestones(e.target.checked)}
                          className="w-4 h-4 rounded border-gray-300 text-orange focus:ring-0 cursor-pointer accent-orange"
                        />
                        <span>{t("milestone")}</span>
                      </label>
                    </TooltipTrigger>
                  </Tooltip>
                </TooltipProvider>
              )}

              {view == ProjectDefaultViewEnumValue.GANTT && (
                <Button
                  variant={
                    isOpenWorkLoad ? "primary" : "primary_outline"
                  }
                  onClick={() => toggleWorkload()}
                  className="h-fit text-xs px-3 py-1.5 shrink-0 whitespace-nowrap font-medium rounded-full hidden"
                  size={"sm"}
                >
                  {t("Work load")}
                </Button>
              )}
            </div>

            {/* Right Tools (Gantt-specific Controls & Legend) */}
            {view == ProjectDefaultViewEnumValue.GANTT && (
              <div className="flex items-center gap-2.5 shrink-0 ml-auto">
                {/* Date Type Selector Segmented Group */}
                <div className="inline-flex items-center bg-gray-50/90 border border-gray-200/80 rounded-lg p-1 shadow-xs shrink-0 gap-1">
                  {options?.map((option) => {
                    const isSelected = selectedDateType === option.value;
                    return (
                      <label
                        key={option.value}
                        className={`flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs cursor-pointer select-none transition-all ${isSelected
                          ? "bg-white shadow-xs text-blue-600 font-semibold"
                          : "text-gray-600 hover:text-gray-900 font-medium"
                          }`}
                      >
                        <input
                          type="radio"
                          name="dateType"
                          value={option.value}
                          checked={isSelected}
                          onChange={() => {
                            setSelectedDateType(
                              option.value as "estimated" | "actual",
                            );
                            setCompare("");
                          }}
                          className="hidden"
                        />
                        <span
                          className={`w-3.5 h-3.5 rounded-full border flex items-center justify-center transition-all ${isSelected
                              ? "border-blue-600 bg-white"
                              : "border-gray-400 bg-white"
                            }`}
                        >
                          {isSelected && (
                            <span className="w-2 h-2 rounded-full bg-blue-600" />
                          )}
                        </span>
                        <span className="whitespace-nowrap">{option.label}</span>
                        <TooltipProvider>
                          <Tooltip>
                            <TooltipTrigger asChild>
                              <span className="flex items-center cursor-pointer opacity-70 hover:opacity-100">
                                <img
                                  src={InfoCircle}
                                  className="h-3.5 w-3.5"
                                  alt="InfoCircle"
                                />
                              </span>
                            </TooltipTrigger>
                            <TooltipContent>
                              <p className="text-sm text-center w-96">
                                {option.tooltip}
                              </p>
                            </TooltipContent>
                          </Tooltip>
                        </TooltipProvider>
                      </label>
                    );
                  })}
                </div>

                {/* Compare Schedules Select */}
                <div className="w-48 shrink-0">
                  <Select
                    key={compare}
                    className="p-0 text-xs"
                    options={[
                      {
                        label: t("Compare schedules"),
                        value: "",
                      },
                      {
                        label: (
                          <div className="flex w-full items-center justify-between gap-2">
                            <span>{t("Estimated VS Actual schedule")}</span>
                            <TooltipProvider>
                              <Tooltip>
                                <TooltipTrigger asChild>
                                  <span
                                    className="flex items-center cursor-pointer opacity-70 hover:opacity-100 shrink-0"
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    <img
                                      src={InfoCircle}
                                      className="h-3.5 w-3.5"
                                      alt="InfoCircle"
                                    />
                                  </span>
                                </TooltipTrigger>
                                <TooltipContent side="right" align="center" className="max-w-xs text-xs">
                                  <p>{t("Current dates tooltip")}</p>
                                </TooltipContent>
                              </Tooltip>
                            </TooltipProvider>
                          </div>
                        ),
                        value: "estimatedToActual",
                      },
                      {
                        label: (
                          <div className="flex w-full items-center justify-between gap-2">
                            <span>{t("Actual VS Recalculated schedule")}</span>
                            <TooltipProvider>
                              <Tooltip>
                                <TooltipTrigger asChild>
                                  <span
                                    className="flex items-center cursor-pointer opacity-70 hover:opacity-100 shrink-0"
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    <img
                                      src={InfoCircle}
                                      className="h-3.5 w-3.5"
                                      alt="InfoCircle"
                                    />
                                  </span>
                                </TooltipTrigger>
                                <TooltipContent side="right" align="center" className="max-w-xs text-xs">
                                  <p>{t("Recalculated schedule tooltip")}</p>
                                </TooltipContent>
                              </Tooltip>
                            </TooltipProvider>
                          </div>
                        ),
                        value: "actualToReCalculated",
                      },
                      {
                        label: t("Compare All"),
                        value: "all",
                      },
                    ]}
                    value={
                      compare === "estimatedToActual"
                        ? { label: t("Estimated VS Actual schedule"), value: "estimatedToActual" }
                        : compare === "actualToReCalculated"
                          ? { label: t("Actual VS Recalculated schedule"), value: "actualToReCalculated" }
                          : compare === "all"
                            ? { label: t("Compare All"), value: "all" }
                            : { label: t("Compare schedules"), value: "" }
                    }
                    onChange={(e: any) => {
                      const val = e as Options;
                      if (val && val.value) {
                        setCompare(
                          val.value as
                          | "estimatedToActual"
                          | "actualToReCalculated"
                          | "all",
                        );
                        setSelectedDateType("estimated");
                      } else {
                        setCompare("");
                      }
                      if (val.value == "actualToReCalculated") {
                        setSelectedDateType("actual");
                      }
                    }}
                    placeholder={t("Compare schedules")}
                    styles={reactSelectStyle}
                    menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                    menuPosition="fixed"
                  />
                </div>

                {/* Compact Legend Pill */}
                <div className="inline-flex items-center gap-2.5 px-3 h-10 bg-gray-50/90 border border-gray-200/80 rounded-lg text-xs text-gray-600 shadow-xs shrink-0 whitespace-nowrap">
                  <span className="font-semibold text-gray-700">{t("legend", "Legend")}:</span>
                  <div className="flex items-center gap-1.5">
                    <div className="w-2.5 h-2.5 rounded-full bg-[#22c55e]"></div>
                    <span>{t("estimated_tooltip", "Estimated")}</span>
                  </div>
                  <div className="flex items-center gap-1.5">
                    <div className="w-2.5 h-2.5 rounded-full bg-[#FF69B4]"></div>
                    <span>{t("Current", "Actual")}</span>
                  </div>
                  <div className="flex items-center gap-1.5">
                    <div className="w-2.5 h-2.5 rounded-full bg-[#525DF9]"></div>
                    <span>{t("Recalculated", "Recalculated")}</span>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="relative flex min-h-0 w-full flex-1 flex-col">
            {(loader || projectQuery.isRefetching || projectQuery.isFetching) ? (
              <Loader className="absolute top-0 left-0 z-50 w-full h-full bg-white" />
            ) : (
              <div className="flex h-full min-h-0 w-full min-w-0 flex-col">
                {view == ProjectDefaultViewEnumValue.LIST &&
                  <div className="flex min-h-0 w-full min-w-0 flex-1 flex-col overflow-hidden">
                    <style>{`
                      .row-checkbox-container, .header-checkbox-container {
                        opacity: 0;
                        transition: opacity 0.2s ease-in-out;
                      }
                      .row-action-hover-group:hover .row-checkbox-container,
                      .row-checkbox-container.is-checked {
                        opacity: 1 !important;
                      }
                      th:hover .header-checkbox-container,
                      .header-checkbox-container:has(input:checked) {
                        opacity: 1 !important;
                      }
                    `}</style>
                    {filterData && filterData.length && (
                      <Table
                        tableClassName={projectsListTableClassName}
                        key={hierarchyData.length}
                        enableColumnCustomization={true}
                        hiddenColumnsKey="projects_list_hidden_columns"
                        expandAll={isExpand}
                        hederClassName="!bg-[#E4E6EB] shadow-[inset_0_-1px_0_0_rgba(0,0,0,0.06)] [&_th]:!px-3 [&_th]:!py-3.5 [&_th]:text-[13px] [&_th]:font-semibold [&_th]:text-gray-800 [&_th]:whitespace-normal [&_th]:leading-snug [&_th]:align-middle"
                        columnDef={
                          columnDef?.map((d) => {
                            const isDateCol = projectsListDateColumnKeys.includes(
                              d.key,
                            );
                            return {
                              ...d,
                              className: () => {
                                return `${d.key === "Action" ? "rounded-e-xl" : ""
                                  } ${isDateCol ? "px-3 py-2.5" : "px-2.5 py-2"} align-middle`.trim();
                              },
                            };
                          }) ?? []
                        }
                        data={hierarchyData}
                        className="h-full min-h-0 w-full min-w-0 flex flex-col !rounded-lg !border !border-gray-200/90 !shadow-sm"
                        onAccordionRender={(data) => innerTable(data)}
                        onRowClassName={(data) => {
                          return `row-action-hover-group group ${data.type === "project" && !data.isActive
                            ? "opacity-70 cursor-not-allowed !border-b "
                            : ""
                            } ${data.type === "portfolio" ? "!bg-secondary/20" : ""
                            } ${data.type === "program" ? "!bg-secondary/10" : ""}`;
                        }}
                        showDropDown={(data) => {
                          return `${data.type === "project" ? "opacity-0 !pl-0 " : "!pl-0"
                            } !rounded-s-xl`;
                        }}
                        showDropDownArrow={(data) => {
                          return `${data.type === "project" ? "opacity-0 !pl-0 " : "!pl-0"
                            }`;
                        }}
                        notShowNoDataFound={true}
                      />
                    )}
                    {!data && (
                      <div className="flex justify-center p-3 w-full">
                        {t("no_projects_available")}
                      </div>
                    )}
                  </div>}
                {view == ProjectDefaultViewEnumValue.GANTT &&
                  (!projectQuery.isRefetching || projectQuery.isFetched) &&
                  filterData &&
                  filterData?.length > 0 && (
                    <div className="flex min-h-0 w-full min-w-0 flex-1 flex-col overflow-hidden">
                      <GanttView
                        key={projectQuery.status + filterData.length}
                        projects={filterData ?? []}
                        setFilterUnit={setFilterUnit}
                        FilterUnit={filterUnit}
                        expandAll={isExpand}
                        selectedDateType={selectedDateType}
                        compare={compare}
                        showMilestones={showMilestones}
                        setSelectedDateType={setSelectedDateType}
                        hierarchyData={hierarchyData}
                        isOpenWorkLoad={isOpenWorkLoad}
                        refetch={projectQuery.refetch}
                        isAdmin={isAdmin}
                        selectedProjectIds={selectedProjectIds}
                        visibleProjectIds={visibleProjectIds}
                        handleSelectRow={handleSelectRow}
                        handleSelectAll={handleSelectAll}
                      />
                    </div>
                  )}
                {filterData &&
                  filterData.length == 0 &&
                  data &&
                  data.length > 0 && <NoFilterProject />}
              </div>

            )}
          </div>
        </div>



        {isOpenPopUp && (
          <CreateUpdateProjectForm
            handleClosePopUp={close}
            editData={editData}
            key={projectId}
          />
        )}
        {projectId && (
          <TaskDetailModal
            taskId={undefined}
            projectId={projectId}
            close={close}
          />
        )}
        <style>{`
          .row-action-hover-group .row-action-buttons {
            display: none !important;
          }
          .row-action-hover-group:hover .row-action-buttons {
            display: flex !important;
          }
        `}</style>
      </>
      {isPopUpOpen && <CreateProjectForm handleClosePopUp={handleOpenPopUp} />}
      <Dialog
        isOpen={Boolean(remove)}
        onClose={() => setRemove(undefined)}
        modalClass="rounded-lg"
      >
        <div className="flex flex-col gap-2 p-6 ">
          <img src={TrashCan} className="w-12 m-auto" />{" "}
          {t("common_delete_message")}
          <div className="flex gap-2 ml-auto">
            <Button
              variant={"outline"}
              disabled={removeProjectMutation.isPending}
              onClick={() => setRemove(undefined)}
            >
              {t("cancel")}
            </Button>
            <Button
              variant={"primary"}
              className="text-white"
              isLoading={removeProjectMutation.isPending}
              disabled={removeProjectMutation.isPending}
              onClick={removeProject}
            >
              {t("delete")}
            </Button>
          </div>
        </div>
      </Dialog>
      <DeletePortfolioProgramConfirmDialog
        isOpen={Boolean(
          deletePortfolioAndProgram?.portfolio ||
          deletePortfolioAndProgram?.program,
        )}
        isPortfolio={!!deletePortfolioAndProgram?.portfolio}
        isLoading={
          removePortfolioMutation.isPending ||
          removeProgramMutation.isPending
        }
        trashIcon={TrashCan}
        onClose={() => setDeletePortfolioAndProgram(undefined)}
        onConfirm={handleRemovePortfolioAndProgram}
      />
      {isShowVideo && (
        <Dialog
          isOpen={isShowVideo}
          onClose={() => { }}
          modalClass="rounded-lg h-[90%] w-[85%] py-4 flex flex-col overflow-hidden relative"
        >
          <div
            className="mt-3 mr-5 justify-end shadow-sm  absolute top-2 right-2 z-50 rounded-full p-3 bg-gray-500/30"
            onClick={() => setIsShowVideo(false)}
          >
            <img
              src={crossNew}
              className="w-5 min-5 brightness-0 cursor-pointer"
            />
          </div>
          <div className="relative w-full h-full">
            <iframe
              src="https://player.vimeo.com/video/1083552233?h=f6ba6f65f9&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;autoplay=1"
              allowFullScreen
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
              }}
              title="ProjectChef Demo"
            ></iframe>
          </div>
        </Dialog>
      )}
      {showUpgradeModal && (
        <Dialog
          isOpen={showUpgradeModal}
          onClose={() => setShowUpgradeModal(false)}
          modalClass="rounded-lg "
          bgClass="!backdrop-blur-sm"
        >
          <div className="flex flex-col gap-4 p-6 w-96 text-center">
            {(!user?.userOrganisation?.some(org => org.role) ||
              user?.userOrganisation?.every(org => org.role === UserRoleEnumValue.COLLABORATOR)) ? (
              t("You do not have access to this dashboard with your current plan. Please contact your administrator to upgrade the current plan")
            ) : (
              t("Project dashboard are not available in this plan. Do you want to upgrade your plan?")
            )}
            <div className="flex gap-2 ml-auto">
              {(!user?.userOrganisation?.some(org => org.role) ||
                user?.userOrganisation?.every(org => org.role === UserRoleEnumValue.COLLABORATOR)) ? (
                <Button
                  variant={"outline"}
                  onClick={() => {
                    setShowUpgradeModal(false);
                  }}
                >
                  {t("ok")}
                </Button>
              ) : (
                <>
                  <Button
                    variant={"outline"}
                    onClick={() => {
                      setShowUpgradeModal(false);
                    }}
                  >
                    {t("cancel")}
                  </Button>
                  <Button
                    variant={"primary"}
                    className="text-white"
                    onClick={() => {
                      navigate("/plans");
                    }}
                  >
                    {t("Upgrade")}
                  </Button>
                </>
              )}
            </div>
          </div>
        </Dialog>
      )}
      {isImportOpen && (
        <HierarchyImportModal
          isOpen={isImportOpen}
          onClose={() => setIsImportOpen(false)}
          onSuccess={() => projectQuery.refetch()}
          downloadTemplate={downloadProjectImportTemplate}
        />
      )}
      
      {/* Bulk Delete Dialog */}
      <Dialog
        isOpen={showBulkDeleteDialog}
        onClose={() => {
          setShowBulkDeleteDialog(false);
          setBulkDeleteConfirmText("");
        }}
        modalClass="w-full max-w-md rounded-2xl p-6"
      >
        <div className="flex flex-col items-center text-center">
          <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center mb-4">
            <img src={TrashCan} className="w-6 h-6 invert-[30%] sepia-[100%] saturate-[1000%] hue-rotate-[340deg]" alt="Delete" />
          </div>
          <h3 className="text-xl font-semibold text-slate-800 mb-2">
            {t("bulk_delete_confirmation_title")}
          </h3>
          <p className="text-slate-600 mb-6 text-sm">
            {t("bulk_delete_confirmation_message").replace("{{count}}", selectedProjectIds.size.toString())}
          </p>
          
          <div className="w-full mb-6">
            <label className="block text-sm font-medium text-slate-700 mb-1 text-left">
              {t("type_delete_to_confirm")}
            </label>
            <input
              type="text"
              value={bulkDeleteConfirmText}
              onChange={(e) => setBulkDeleteConfirmText(e.target.value)}
              className="w-full rounded-xl border border-slate-200 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all"
              placeholder="DELETE"
            />
            {bulkDeleteConfirmText.length > 0 && bulkDeleteConfirmText !== "DELETE" && (
              <p className="text-red-500 text-xs mt-1 text-left">
                {t("bulk_delete_type_mismatch")}
              </p>
            )}
          </div>

          <div className="flex w-full gap-3">
            <Button
              variant="outline"
              className="flex-1 rounded-xl"
              onClick={() => {
                setShowBulkDeleteDialog(false);
                setBulkDeleteConfirmText("");
              }}
              disabled={bulkDeleteMutation.isPending}
            >
              {t("cancel")}
            </Button>
            <Button
              variant="destructive"
              className="flex-1 rounded-xl bg-red-500 hover:bg-red-600 text-white"
              onClick={handleBulkDelete}
              disabled={bulkDeleteConfirmText !== "DELETE"}
              isLoading={bulkDeleteMutation.isPending}
            >
              {t("bulk_delete")}
            </Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default ProjectsList;
